module.exports = __webpack_public_path__ + "img/step1.190374ad.svg";